import { createStore } from "vuex";

// modules
import user from "@/store/user";
import app from "@/store/app";
import speakers from "@/store/speakers";
import sponsors from "@/store/sponsors";
import VuexPersistence from "vuex-persist";
import program from "@/store/program";
import event from "@/store/event";

const vuexLocalSession = new VuexPersistence({
  storage: window.sessionStorage,
  modules: ["user"],
});

export default createStore({
  state: {},
  mutations: {},
  actions: {},
  modules: { user, app, speakers, program, sponsors, event },
  plugins: [vuexLocalSession.plugin],
});
